import React from "react";
import { Field, ErrorMessage } from "formik";

function Input(props) {
  const { name, label, lableClassName, displayError, ...rest } = props;
  // console.log("label",label);
  return (
    <React.Fragment>
      {typeof label !== "undefined" && (
        <label htmlFor={name} className={lableClassName}> {label}</label>
      )}

      <Field name={name} {...rest} />
      {displayError && 
      <p className="text-danger mb-0">
        <ErrorMessage name={name} />
      </p>}
      
    </React.Fragment>
  );
}
export default Input;
